<template>
  <div class="container">
    <van-nav-bar :title="title" left-text="" right-text="确定"
      left-arrow @click-left="onClickLeft" @click-right="onSearch()">
    </van-nav-bar>
    <div class="main">
      <van-cell v-if="pageType >= 3" title="选择日期范围" is-link arrow-direction="down" :value="showTime" @click="showCalendar = true" />
      <van-search :maxlength='maxlength' v-model="keyword" @input="checkSearch" @search="onSearch" shape="round" :placeholder="placeholder" />
      <van-calendar allow-same-day type="range" v-model="showCalendar" :min-date="minDate" :max-date="maxDate" :show-confirm="false" @confirm="onConfirm" />
      <div class="title">历史搜索</div>
      <div class="list-box">
        <div class="list" @click="selKey(item)" :key="index" v-for="(item,index) in historyList">{{item}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Loading,Search,Calendar,Cell} from 'vant';
  export default {
    data() {
      return {
        pageType:'',//页面来源
        title:"搜索",
        keyword: '',
        minDate: '',
        maxDate: '',
        startTime: '',
        endTime: '',
        showTime: '',
        maxlength: 100,
        showCalendar: false,
        historyList:[],
        placeholder:'请输入项目名称、城市名称'
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Search.name]:Search,
      [Calendar.name]:Calendar,
      [Cell.name]:Cell,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      getUrlParam (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = (window.location.search.substr(1) || window.location.hash.split('?')[1])['match'](reg)
        if (r != null) return decodeURI(unescape(r[2]))
        else return null
      },
      selKey(searchName){
        this.keyword = searchName;
        this.onSearch();
      },
      checkSearch(){
        //pageType 1-在管项目  2-管理设备  3-充电记录 4-客户留资  5-历史充电 7-卡片管理
        if(this.pageType == 1){
          var regx = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
          if(!regx.test(this.keyword)){
            this.keyword = '';
          }
        }else if(this.pageType == 2){
          var regx = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
          if(!regx.test(this.keyword)){
            this.keyword = '';
          }
        }else if(this.pageType == 7){
          var regx = /^[A-Za-z0-9.\u4e00-\u9fa5]+$/;
          if(!regx.test(this.keyword)){
            this.keyword = '';
          }
        }else{
          let regx = /^[0-9]+$/;
          if(!regx.test(this.keyword)){
            this.keyword = '';
          }
        }  
      },
      onSearch(){
        //pageType 1-在管项目  2-管理设备  3-充电记录  4-客户留资 5-历史充电 7-卡片管理
        if(this.pageType == 1){
          this.$router.replace({path: 'projectList.html',query:{keyword:this.keyword}})
        }else if(this.pageType == 2){
          this.$router.replace({path: 'deviceList.html',query:{keyword:this.keyword}})
        }else if(this.pageType == 3){
          this.$router.replace({path: 'chargeList.html',query:{startTime:this.startTime,endTime:this.endTime,keyword:this.keyword}})
        }else if(this.pageType == 4){
          this.$router.replace({path: 'khList.html',query:{startTime:this.startTime,endTime:this.endTime,keyword:this.keyword}})
        }else if(this.pageType == 5){
          this.$router.replace({path: 'historyChargeList.html',query:{startTime:this.startTime,endTime:this.endTime,keyword:this.keyword}})
        }else if(this.pageType == 7){
          this.$router.replace({path: 'cardManageList.html',query:{startTime:this.startTime,endTime:this.endTime,keyword:this.keyword}})
        }
      },
      gethistoryList() {
        let searchType = this.pageType;
        if(this.pageType == 5){
            searchType = 3;
        }
        axios.get("/device/searchhistorylist?searchType="+searchType,{
        }).then((res)=>{
          this.historyList = res.data;
        })
      },
      onClickLeft() {
        if(this.pageType == 1){
          this.$router.replace({path: 'projectList.html'})
        }else if(this.pageType == 2){
          this.$router.replace({path: 'deviceList.html'})
        }else if(this.pageType == 3){
          this.$router.replace({path: 'chargeList.html'})
        }else if(this.pageType == 4){
          this.$router.replace({path: 'khList.html'})
        }else if(this.pageType == 5){
          this.$router.replace({path: 'historyChargeList.html'})
        }else if(this.pageType == 7){
          this.$router.replace({path: 'cardManageList.html'})
        }
      },
      onConfirm(date) {
        this.startTime = this.$moment(date[0]).format('YYYY-MM-DD') +' 00:00:00';
        this.endTime = this.$moment(date[1]).format('YYYY-MM-DD') +' 23:59:59';
        this.showTime = this.$moment(this.startTime).format('MM-DD') +'~'+ this.$moment(this.endTime).format('MM-DD');
        this.showCalendar = false;
        console.log(this.startTime,this.endTime)
      },
      resetDate(){
        let date = new Date();
        if(this.pageType==3){
           //最小允许选择3月前日期
            this.minDate = new Date(this.$moment(date).add('-3','months').format('YYYY/MM/DD'));
        }else{
           //最小允许选择一年前日期
            this.minDate = new Date(this.$moment(date).add('-1','year').format('YYYY/MM/DD'));
        }
        //最大允许选择当前日期
        this.maxDate = new Date(this.$moment(date).format('YYYY/MM/DD'));
      },
      onClickRight() {
        
      },
    },
    computed:{
    },
    created () {    
      this.pageType = this.$route.query.pageType;
      this.resetDate();
      this.gethistoryList();
      if(this.pageType == 1){
        this.placeholder = '请输入项目名称、城市名称';
      }else if(this.pageType == 2){
        this.placeholder = '请输入项目名称、设备编号';
      }else if(this.pageType == 3){
        this.title = "搜索最近充电记录"
        this.maxlength = 11;
        this.placeholder = '请输入用户手机号';
      }else if(this.pageType == 4){
        this.maxlength = 11;
        this.placeholder = '请输入用户手机号';
      }else if(this.pageType == 5){
        this.title = "搜索历史充电记录"
        this.maxlength = 11;
        this.placeholder = '请输入用户手机号';
      }else if(this.pageType == 7){
        this.title = "搜索卡片"  
        this.placeholder = '请输入用户手机号、虚拟卡号';
      }
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #fff;
  }
  .main{
    width: 100%;
    height: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .title{
    font-size: 16px;
    color: #373737;
    padding: 10px 20px;
  }
  .list-box{
    color: #373737;
    box-sizing: border-box;
    .list{
      font-size: 14px;
      padding: 6px 20px;
      box-sizing: border-box;
      word-break: break-all;
      display: inline-block;
      max-width: 100%;
      margin: 12px;
      background: #f7f8f9;
      border-radius: 30px;
    }
  }
</style>
